import * as React from 'react';

interface IChangeObserverProps<T> {
    onChange?: (value: T) => void,
    value: T,
}
export function ChangeObserver<T>(props: IChangeObserverProps<T>) {
    const firstRender = React.useRef(true);
    const oldValue = React.useRef<T>(props.value);

    React.useEffect(() => {
        const first = firstRender.current;
        if (firstRender.current)
            firstRender.current = false;
        if (!first) {
            if (oldValue.current !== props.value) {
                oldValue.current = props.value;
                props.onChange?.(props.value);
            }
        }
    }, [props.value, props.onChange]);

    return <></>;
}
